import React from 'react';
import { ShieldCheck, Zap, RefreshCw } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  return <section className="relative bg-slate-950 text-white py-4 overflow-hidden" data-id="element-49">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-orange-500 via-slate-900 to-slate-950" data-id="element-50"></div>

      <div className="max-w-7xl mx-auto px-4 relative z-10" data-id="element-51">
        <div className="flex flex-col space-y-2 text-center" data-id="element-52">
          <h1 className="text-2xl md:text-3xl font-heading font-bold leading-tight text-balance uppercase" data-id="element-53">
            CONSTRUÍ PROYECTOS DE HERRERÍA PROFESIONALES{' '}
            <span className="text-orange-500" data-id="element-54">EN 24 HORAS</span>
          </h1>

          <p className="text-base md:text-lg text-slate-300 font-medium text-balance" data-id="element-55">
            +600 PLANOS METÁLICOS CON MEDIDAS EXACTAS, LISTOS PARA FABRICAR
          </p>

          {/* Book Mockup Image */}
          <div className="flex justify-center" data-id="element-56">
            <img src="https://cdn.magicpatterns.com/uploads/fswsC8QPNffctvnHepsQkS/3f7b2d0b-6cab-4bee-8bbf-e691529338ad.jpg" alt="Sistema Listo Para Fabricar - Sistema operativo de un taller rentable" className="w-full max-w-md rounded-xl shadow-2xl shadow-orange-500/10" data-id="element-57" />
          </div>

          <div className="pt-2" data-id="element-58">
            <CTAButton data-id="element-59">QUIERO LOS +600 PLANOS ►</CTAButton>

            <div className="mt-2 flex flex-wrap items-center justify-center gap-3 text-xs text-slate-400 font-medium" data-id="element-60">
              <div className="flex items-center" data-id="element-61">
                <ShieldCheck className="w-3.5 h-3.5 mr-1 text-green-500" data-id="element-62" />
                Garantía 7 Días
              </div>
              <div className="flex items-center" data-id="element-63">
                <Zap className="w-3.5 h-3.5 mr-1 text-yellow-500" data-id="element-64" />
                Acceso Inmediato
              </div>
              <div className="flex items-center" data-id="element-65">
                <RefreshCw className="w-3.5 h-3.5 mr-1 text-blue-500" data-id="element-66" />
                Actualizaciones de por vida
              </div>
            </div>

            <div className="flex items-center justify-center gap-1 text-xs mt-1" data-id="element-67">
              <span className="text-orange-400 font-bold tracking-wide" data-id="element-68">
                ★★★★★
              </span>
              <span className="text-slate-300 font-semibold" data-id="element-69">4.9/5</span>
              <span className="text-slate-400" data-id="element-70">+2.554 Herreros</span>
              <span className="text-green-500 font-bold" data-id="element-71">✔</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}